import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	errorFlagTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.flag-group.release-feature-disabled-scheduling-failure-error-flag.error-flag-title',
		defaultMessage: 'Something went wrong',
		description: 'Title of error flag.',
	},
	errorFlagDescription: {
		id: 'portfolio-3-portfolio.app-simple-plans.flag-group.release-feature-disabled-scheduling-failure-error-flag.error-flag-description',
		defaultMessage:
			'Releases have been turned off in your plan. Reload your plan and run the auto-scheduler again.',
		description: 'Description of error flag.',
	},
	errorFlagIconLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.flag-group.release-feature-disabled-scheduling-failure-error-flag.error-flag-icon-label',
		defaultMessage: 'Error',
		description: 'ARIA label for an error icon.',
	},
	reloadPlan: {
		id: 'portfolio-3-portfolio.app-simple-plans.flag-group.release-feature-disabled-scheduling-failure-error-flag.error-flag-reload-plan',
		defaultMessage: 'Reload plan',
		description: 'An action that reload the plan',
	},
});

export default messages;
